// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"504":"2e543c1b","872":"189e1d60"}[chunkId] + ".chunk.css";
};